import { forwardRef } from 'react';
import { Container, InputAutoCompleteContainer } from './styles';
import { AutoCompleteProps } from 'antd';
import './styles.css';
export interface InputAutocompleteProps extends AutoCompleteProps {
  error?: boolean;
  helperText?: string;
  label?: string;
}

const InputAutocomplete = forwardRef<HTMLInputElement, InputAutocompleteProps>(
  ({ helperText, label, ...rest }, ref) => {
    return (
      <Container className='input-autocomplete'>
        {label && <label>{label}</label>}
        <InputAutoCompleteContainer {...rest} style={{}} />

        {helperText && <span>{helperText}</span>}
      </Container>
    );
  }
);

export default InputAutocomplete;
